<div class="button-navigation flex row-collapse items-center space-between w-100">
  <div>
    <button pButton class="atlas-btn atlas-btn-secondary tall" type="button"
      title="{{ 'profiles.relationships.back-to-profile' | translate | uppercase }}"
      [routerLink]="['/profile', profileId]" [icon]="'pi pi-angle-left'"
      [label]="'profiles.relationships.back-to-profile' | translate | uppercase">
    </button>
  </div>
  <div class="flex row-collapse gap-20px">
    <button class="atlas-btn atlas-btn-primary tall" type="button"
      title="{{ 'profiles.relationships.relate-existing' | translate | uppercase }}" (click)="relateExistingProfile()"
      *ngIf="relatedProfileAccess === 2">
      {{ 'profiles.relationships.relate-existing' | translate | uppercase }}
    </button>
    <button class="atlas-btn atlas-btn-primary tall" type="button"
      title="{{ 'profiles.relationships.relate-new' | translate | uppercase }}" (click)="relateNewClick()"
      *ngIf="relatedProfileAccess === 2">
      {{ 'profiles.relationships.relate-new' | translate | uppercase }}
    </button>
  </div>
</div>

<span class="title-header">{{ 'profiles.relationships.title' | translate | titlecase }}</span>

<div class="profile-header flex row-collapse items-center gap-5px">
  <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.OrgInd"
    [memberTypeIconColor]="profile.MemberTypeIconColor"
    [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"></wl-profile-type-icon>
  <div class="profile-name-id">
    {{ profile.ReportName }}
  </div>
  <span style="color: #999; font-size: 15px">({{ profile.ProfileId }})</span>
</div>

<wl-profile-relationship-grid [(searchParams)]="searchParams" (editClicked)="onEditClicked($event)"
  (deleteClicked)="onDeleteClicked($event)"></wl-profile-relationship-grid>

<p-dialog modal="true" [(visible)]="showEdit" [closable]="false" [minY]="350" styleClass="atlas-dialog-l"
  [focusOnShow]="false" [contentStyle]="{ 'max-height': '75vh' }">
  <wl-profile-edit [preventLoad]="false" [hideSaveButtons]="true"></wl-profile-edit>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn btn-default" (click)="closeEdit()">{{ 'common.cancel' | translate |
      uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="saveOpenProfile()" [disabled]="isSaving">
      <span *ngIf="!isSaving">{{ 'profiles.view.add-member.save-and-close' | translate | uppercase }}</span>
      <wl-busy [show]="isSaving"></wl-busy>
    </button>
  </ng-template>
</p-dialog>

<wl-profile-relate-existing [profileId]="profileId"></wl-profile-relate-existing>

<wl-profile-create [parentProfileId]="profileId" [suspendNavigateAway]="true"></wl-profile-create>
